import React, {useState} from "react";
import { GoogleLogin } from "react-google-login";
import { Divider } from "semantic-ui-react";
import { googleurl } from "../../config";
import { LinkedInLoginButton, FacebookLoginButton, GoogleLoginButton } from 'react-social-login-buttons';

import "./GoogleDivider.css";

function GoogleDivider(props) {
  let userType = window.localStorage.getItem('userType')
  let isRegistered = props.isRegistered ?? false;

  return (
    <>
      <div className="row justify-content-center">
        <div className={'col-12 col-md-6 d-flex justify-content-center align-items-center'}>
          <div className='signup-google-button'>
            <GoogleLogin
              clientId={googleurl}
              buttonText={props.buttonText}
              onSuccess={props.onSuccess}
              onFailure={props.onFailure}
              cookiePolicy={"single_host_origin"}
              theme="dark"
              style={{ width: '190px' }}
              // disabled={userType === null || userType === "null"}
              disabledStyle={{ backgroundColor: "lightgrey", cursor: "unset" }}
              className='signup-google-button'
            />
          </div>
        </div>
      </div>

      {props.linkedinText ? 
      <div className="row justify-content-center">
        <div className={'col-12 col-md-6 d-flex justify-content-center align-items-center'}>
          <div className='signup-google-button'>
            <LinkedInLoginButton
              onClick={props.linkedinClick}
              text={props.linkedinText}
              style={{fontSize:'14px', width: '190px', margin: 0, height: '43px' }}
              className={'signup-google-button'}
            />
          </div>
        </div>
      </div>
      : null}
      {/* {props.fbText ?
      <div className="row justify-content-center">
        <div className="col-12 col-md-6">
          <div className="signup-google-button">
            <FacebookLoginButton
              onClick={props.fbClick}
              text={props.fbText}
              style={{fontSize:'14px'}}
            />
          </div>
        </div>
      </div>
      :null} */}

      <div className="row justify-content-center">
        <div className="col-12">
          <div className="textHeader">
            <i>
              To login with Google, please allow Third Party Cookies in your settings
            </i>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12">
          <div className="signup-divider">
            <Divider horizontal>Or</Divider>
          </div>
        </div>
      </div>

    </>
  );
}

export default GoogleDivider;
